import React, { useState, useEffect } from 'react';
import './BookingDetailsPage.css';
import CollapsibleGrid from '../CollapsibleGrid/CollapsibleGrid'; // Adjust the import path as necessary
import FetchService from '../../api/FetchService';
import dayjs from 'dayjs';
import 'dayjs/locale/nb'; // Import Norwegian locale file // Import dayjs
import OrderPlan from '../OrderPlans/OrderPlan';
import LoadingOverlay from 'react-loading-overlay';
import { isLoggedIn } from "../../api/NewLoginService";
import { Modal, Alert, Toast, ToastContainer } from 'react-bootstrap'
import { useLocation, useNavigate } from "react-router-dom";
import BookingApproval from '../BookingApproval/BookingApproval';
import BookingHelper from "./BookingHelper";





function BookingDetailsPageAdmin    () {
    const [userObject, setUser] = useState(isLoggedIn());
    const [bookings, setBookings] = useState(null);
    const [error, setError] = useState(null);
    const [subCategories, setSubCategories] = useState([]);

    const [searchQuery, setSearchQuery] = useState("");
    const [currentBooking, setCurrentBooking] = useState("");

    const [isLoading, setLoading] = useState(false);

    const [showPopup, setShowPopup] = useState(false);
    const [showPopup2, setShowPopup2] = useState(false);



    const [showConfirmSaveModal, setShowConfirmSaveModal] = useState(false); // confirmation modal
    const [showReviewChangesModal, setShowReviewChangesModal] = useState(false); // confirmation modal


    const [selectedRow, setSelectedRow] = useState(null);

    const [statusConfigs, setStatusConfigs] = useState({});

    const [showDeletePopup, setShowDeletePopup] = useState(false);

    const [showModalDone, setShowModalDone] = useState(false);
    const [showModalMessage, setShowModalMessage] = useState("");
    // ✅ State
    const [showCancelPopup, setShowCancelPopup] = useState(false);

    const [activeTab, setActiveTab] = useState('PENDING_CONFIRM'); // 🔹 global state for selected tab



    const location = useLocation();




    const CategoryObjecy = (id) => {

        id = id || -1;
        let categoryObject = subCategories.filter(obj => obj.id == id);
        return categoryObject[0];
    }



    const refreshTimerRef = React.useRef(null);

    const stopAutoRefresh = () => {
        if (refreshTimerRef.current) {
            clearInterval(refreshTimerRef.current);
        }
    };

    const fetchStatuses = () => {
        FetchService.GetAllSubCategories()
            .then((data) => {
                try {
                    if (subCategories.length > 0) return; // Skip if already loaded

                    const formattedData = data.data.map((sub) => ({
                        value: sub.name,
                        id: sub.id,
                        icon: sub.icon,
                    }));

                    formattedData.push({
                        value: "EGEN PLANLAGT AKTIVITET",
                        id: "0",
                        icon: "",
                    });

                    setSubCategories(formattedData);

                    // Fetch booking statuses after subcategories
                    return FetchService.GetAllBookingStatus("ADMIN");
                } catch (err) {
                    console.error("Error while processing subcategories:", err);
                }
            })
            .then((data) => {
                if (!data) return; // safeguard if skipped above
                const json = data.data;
                const configs = {};
                json.forEach((s) => {
                    configs[s.statusCode.toLowerCase()] = {
                        text: s.displayStatus,
                        dotColor: s.colorCode,
                        statuscode: s.statusCode,
                    };
                });
                setStatusConfigs(configs);
            })
            //.catch((err) => {
            //    console.error("Failed to fetch subcategories or booking statuses:", err);
            //    setError("Failed to load subcategories or statuses");
            //    setLoading(false);
            //});
    };

    const RefreshData = () => {
        setLoading(true);

        // clear old interval if exists
        if (refreshTimerRef.current) {
            clearInterval(refreshTimerRef.current);
        }

        refreshTimerRef.current = setInterval(() => {
            FetchService.GetAllBusinessBooking(
                userObject?.user?.userTypeId === 3 ? userObject?.user?.id : null
            )
                .then((val) => {
                    val.data = val.data.map((obj) => {
                        const statusConfig = getStatusConfig(obj.status); // uses statusConfigs

                        obj.name =
                            " <span class='relative inline-block align-middle ml-1 mr-3 -mt-5 z-1'>" +
                            "<i class='ri-calendar-line text-gray-700 align-middle'></i>" +
                            "<span class='absolute -bottom-9 -right-2 flex h-5 w-5 items-center justify-center " +
                            "rounded-full bg-orange-500 text-white text-ms font-semibold shadow'>" +
                            (obj.activities?.length ?? 0) +
                            "</span>" +
                            "</span>" +
                            "<span class='align-middle booking-name-box'>" +
                            obj.bookingName +
                            "</span>";

                        obj.statushtml = `<div class="dflex">
                        <div class="status-dot" style="background-color: ${statusConfig?.dotColor}"></div>
                        <span class="status-text">${statusConfig?.text}</span>
                    </div>`;

                        obj.statusHeading = `<div class="dflex">
                        <div class="badge-hd" style="background-color: ${statusConfig?.dotColor}">
                            <span class="status-text">${statusConfig?.text}</span>
                        </div>
                    </div>`;

                        obj.bookingDateOrg = dayjs(obj.bookingDate)
                            .locale("nb")
                            .format("DD. MMMM YYYY")
                            .toUpperCase();

                        obj.orderID = "ODR-" + obj.businessBookingId;
                        return obj;
                    });

                    setBookings(val);
                    setLoading(false);
                })
                //.catch((e) => {
                //    console.error("Failed to fetch bookings:", e);
                //    setError("Failed to fetch bookings");
                //    setLoading(false);
                //});
        }, 10000);
    };

  


    useEffect(() => {
        setLoading(true);
        fetchStatuses();
    }, []);

    useEffect(() => {
        if (Object.keys(statusConfigs).length > 0 && Object.keys(subCategories).length > 0) {
            setLoading(true);

            RefreshData();
        }
    }, [statusConfigs,subCategories]);


    const handleEdit = (row) => {
        setSelectedRow(row);
        let session = JSON.parse(row.sessionData);
        sessionStorage.setItem("recommendState", JSON.stringify(session));
        setShowPopup(true);
    };


    const handleEdit2 = (row) => {
        setSelectedRow(row);
        let session = JSON.parse(row.sessionData);
        sessionStorage.setItem("recommendState", JSON.stringify(session));
        setShowPopup2(true);
    };



    const handleEditSaveChanges = (row, cstMsg = null, OpertaionCstm ="EDITED") => {

        debugger;
        

        setLoading(true)

        const Operation = OpertaionCstm ? OpertaionCstm : "EDITED";
        // decide new status row.
        const newStatus = "CHANGES_REQUIRED_USER";

        // 🔹 Remove the deleted activities from payload
        const updatedRow = row;

        const isSame = BookingHelper.areActivitiesSame(selectedRow.activities, row.activities);

        if (isSame) {
            // ✅ Activities changed → update booking
            FetchService.UpdateBusinessBookinglRequest(updatedRow).then(() => {
                setShowModalDone(true);
                setShowModalMessage("Forespørselen din er ikke endret, men bestillingen er oppdatert.");
                setTimeout(() => {
                    setLoading(false);
                    RefreshData();
                }, 3000); // waits 3 seconds

            });

        } else {
            // 🔹 Then update status

            FetchService.GenerateBookingEmail(makeBookingEmailData(updatedRow, Operation))
                .then(() => {
                    FetchService.UpdateBusinessBookinglRequest(updatedRow).then(() => {
                        FetchService.UpdateBookingStatus(updatedRow.businessBookingId, newStatus)
                            .then(() => {



                                setShowDeletePopup(false);
                                setShowModalDone(true);

                                setShowModalMessage(cstMsg ? cstMsg : "Bookingforespørselen har blitt endret og venter på godkjenning fra B2B kunden.");
                                // refresh parent grid/list here if needed
                                setTimeout(() => {
                                    setLoading(false);
                                    RefreshData();
                                }, 3000); // waits 3 seconds
                                //console.log(`Updating booking ${row.businessBookingId} → ${newStatus}`);

                            })
                            .catch((err) => {
                                console.error("Update failed", err);
                            });
                    })

                })
                .catch((err) => {
                    console.error("Update failed", err);
                })
             

        }
    };




    const handleShowReviewChanges = (row) => {
        setSelectedRow(row);
        setShowReviewChangesModal(true);
    };


    const checkPendingorPickStatus = (row) => {
        
        if ((row.status == "PENDING_CONFIRM")) {
            return true;
        }
        return false;
    };

    const checkEditVisibility = (row) => {
        
        if ((row.status == "PENDING_CONFIRM" || row.status == "CONFIRMED")) {
            return true;
        }
        return false;
    };


    const handleConfirmBookingChanges = (row,newOperation=null) => {

        
        setLoading(true);

        // total vs deleted
        const total = row.activities.length;

        const Operation = newOperation ? newOperation : "CONFIRMED";
        // decide new status row.
        const newStatus = "CONFIRMED";

        // 🔹 Remove the deleted activities from payload
        const updatedRow = row;

        // 🔹 Then update status

        FetchService.GenerateBookingEmail(makeBookingEmailData(updatedRow, Operation))
            .then(() => {
                

                FetchService.UpdateBusinessBookinglRequest(updatedRow).then(() => {

                FetchService.UpdateBookingStatus(row.businessBookingId, newStatus)
                    .then(() => {
                        
                            setShowModalDone(true);
                            setShowModalMessage("Denne bookingforespørselen er bekreftet, og kunden har mottatt epostbekreftelse.");
                            // refresh parent grid/list here if needed
                            setTimeout(() => {
                                setLoading(false);
                                RefreshData();
                            }, 3000); // waits 3 seconds
                        //    console.log(`Updating booking ${row.businessBookingId} → ${newStatus}`);
                        })

                    })
                    .catch((err) => {
                        console.error("Update failed", err);
                    });
            })
            .catch((err) => {
                console.error("Update failed", err);
            })
         
    };

  

    


    const handleDeleteSaveChanges = (row) => {
        


        setLoading(true);

        // total vs deleted
        const total = row.activities.length;
        const deletedCount = row.activities.filter(a => a.isDeleted).length;

        const Operation = (deletedCount === total || total === 1) ? "DELETED" : "PARTIAL_DELETED";
        // decide new status row.
        const newStatus = (deletedCount === total || total === 1) ? "DELETED" : "PENDING_CONFIRM";

        // 🔹 Remove the deleted activities from payload
        const updatedRow = row;

  

        // 🔹 Then update status

        FetchService.GenerateBookingEmail(makeBookingEmailData(updatedRow, Operation))
            .then(() => {


                FetchService.UpdateBookingStatus(row.businessBookingId, newStatus)
                    .then(() => {


                        // 🔹 First update booking data if not fully deleted
                        if (deletedCount < total && total > 1) {
                            FetchService.UpdateBusinessBookinglRequest(updatedRow);
                        }

                        setShowDeletePopup(false);
                        setShowModalDone(true);

                        if (Operation === "PARTIAL_DELETED") {
                            setShowModalMessage(
                                "B2B kunden sin bookingforespørsel er delvis slettet og oppdatert. Kunden har mottatt en mail med denne informasjonen."
                            );
                        }
                        else {
                            setShowModalMessage("Dessverre kan Funtlers ikke godkjenne denne bookingforespørselen. Den er derfor slettet, men du er hjertelig velkommen til å legge inn en ny bestilling.");
                        }
                        // refresh parent grid/list here if needed
                        setTimeout(() => {
                            setLoading(false);
                            RefreshData();
                        }, 3000); // waits 3 seconds
                        //console.log(`Updating booking ${row.businessBookingId} → ${newStatus}`);

                    })
                    .catch((err) => {
                        console.error("Update failed", err);
                    });
            })
            .catch((err) => {
                console.error("Update failed", err);
            })
         
    };


    const handleReviewChangesRequest = (data) => {
        debugger;
        
        setShowReviewChangesModal(false);

        // total vs deleted
        const total = data.activities.length;
        const isApprovedCount = data.activities.filter(x => x.isApproved).length;
        const isCanceledCount = data.activities.filter(x => x.isCanceled).length;


        if (isApprovedCount === total) {
            data.activities = data.activities.map(x => ({
                ...x,
                reason: null
            }));
            handleConfirmBookingChanges(data,"CONFIRMED_ACCEPTED");
        }
        else if (isCanceledCount === total) {
            handleCancelSaveChanges(data);
        }
        else {
            handleCancelPartialChanges(data);
        }




    }


    const makeBookingEmailData = (bookingdata, Status) => {
        const emailJobs = [];

        debugger;
        switch (Status) {
            case "DELETED":
                emailJobs.push(
                    {
                        businessBookingModel: bookingdata,
                        emails: ["sa@funtlers.com"],
                        state: "sp_DeleteAllBusinessBookingEmail",
                        title: "Funtlers har dessverre måtte avslå din bookingforespørsel.",
                    },
                    {
                        businessBookingModel: bookingdata,
                        emails: [bookingdata?.userEmail],
                        state: "sp_DeleteAllBusinessBookingEmail",
                        title: "Funtlers har dessverre måtte avslå din bookingforespørsel.",
                    }
                );
                break;

            case "PARTIAL_DELETED":
                emailJobs.push(
                    {
                        businessBookingModel: bookingdata,
                        emails: ["sa@funtlers.com"],
                        state: "sp_PartialDeleteBusinessBookingEmail",
                        title: "Funtlers har dessverre måtte avslå deler av din bookingforespørsel.",
                    },
                    {
                        businessBookingModel: bookingdata,
                        emails: [bookingdata?.userEmail],
                        state: "sp_PartialDeleteBusinessBookingEmail",
                        title: "Funtlers har dessverre måtte avslå deler av din bookingforespørsel.",
                    }
                );
                break;


            case "EDITED_CONFIRM":
                emailJobs.push(
                    {
                        businessBookingModel: bookingdata,
                        emails: ["sa@funtlers.com"],
                        state: "sp_EditAllBusinessBookingEmail",
                        title: "B2B Kunden har mottatt din forespørsel om endringer!",
                        subject: "B2B Kunden har mottatt din forespørsel om endringer!",
                        extraInformation: {
                            "description": "Kunden har blitt bedt om å gå inn i Funtlers plattformen for å godkjenne/avslå endringene innen 3 virkedager.",
                            "footerText": "Ta kontakt med B2B kunden dersom de ikke svarer på ønskede endringer snarlig."
                        }
                    },

                    {
                        businessBookingModel: bookingdata,
                        emails: [bookingdata?.userEmail],
                        state: "sp_EditAllBusinessBookingEmail",
                        title: "Funtlers har forespurt endringer!",
                        subject: "Funtlers har forespurt endringer!",
                        extraInformation: {
                            "description": "Vennligst gå inn i Funtlers plattformen for å godkjenne/avslå endringene innen 3 virkedager.",
                            "footerText": "Ta kontakt med kundeservice på support@funtlers ved eventuelle spørsmål."
                        }
                    }
                );
                break;


            case "EDITED":
                emailJobs.push(
                    {
                        businessBookingModel: bookingdata,
                        emails: ["sa@funtlers.com"],
                        state: "sp_EditAllBusinessBookingEmail",
                        title: "Dere i Funtlers har forespurt endringer!",
                        subject: "Dere i Funtlers har forespurt endringer!",
                        extraInformation: {
                            "description": "Dere i Funtlers har forespurt endringer på markerte aktiviteter under, og disse avventer bekreftelse fra B2B kunde før endelig booking er fullført.",
                            "footerText": "Ta kontakt med B2B kunden dersom de ikke svarer på ønskede endringer snarlig."
                        }
                    },
                    {
                        businessBookingModel: bookingdata,
                        emails: [bookingdata?.userEmail],
                        state: "sp_EditAllBusinessBookingEmail",
                        title: "Funtlers har forespurt endringer!",
                        subject: "Funtlers har forespurt endringer!",
                        extraInformation: {
                            "description": "Dere i Funtlers har forespurt endringer på markerte aktiviteter under, og disse avventer bekreftelse fra B2B kunde før endelig booking er fullført.",
                            "footerText": "Ta kontakt med kundeservice på support@funtlers ved eventuelle spørsmål."
                        }
                    }
                );
                break;

            case "CANCELLED":
                emailJobs.push(
                    {
                        businessBookingModel: bookingdata,
                        emails: ["sa@funtlers.com"],
                        state: "sp_CancelAllBusinessBookingEmail",
                        title: "Funtlers har dessverre måtte avbestille din booking.",
                        subject:"Funtlers har dessverre måtte avbestille din booking."
                    },
                    {
                        businessBookingModel: bookingdata,
                        emails: [bookingdata?.userEmail],
                        state: "sp_CancelAllBusinessBookingEmail",
                        title: "Funtlers har dessverre måtte avbestille din booking.",
                        subject:"Funtlers har dessverre måtte avbestille din booking."
                    }
                );
                break;

            case "PARTIAL_CANCELLED":
                emailJobs.push(
                    {
                        businessBookingModel: bookingdata,
                        emails: ["sa@funtlers.com"],
                        state: "sp_PartialCancelBusinessBookingEmail",
                        title: "Funtlers har dessverre måtte avbestille deler av din booking.",
                        subject:"Funtlers har dessverre måtte avbestille deler av din booking."
                    },
                    {
                        businessBookingModel: bookingdata,
                        emails: [bookingdata?.userEmail],
                        state: "sp_PartialCancelBusinessBookingEmail",
                        title: "Funtlers har dessverre måtte kansellere deler av din booking.",
                        subject: "Funtlers har dessverre måtte avbestille deler av din booking."
                    }
                );
                break;

            case "CONFIRMED":
                emailJobs.push(
                    {
                        businessBookingModel: bookingdata,
                        emails: ["sa@funtlers.com"],
                        state: "sp_ConfirmBusinessBookingEmail",
                    },
                    {
                        businessBookingModel: bookingdata,
                        emails: [bookingdata?.userEmail],
                        state: "sp_ConfirmBusinessBookingEmail",
                    }
                );
                break;



            case "CONFIRMED_ACCEPTED":
                emailJobs.push(
                    {
                        businessBookingModel: bookingdata,
                        emails: ["sa@funtlers.com"],
                        state: "sp_ConfirmBusinessBookingEmail",
                        title: "Funtlers har gitt tilbakemelding på dine forespurt endringer!",
                        subject: "Funtlers har gitt tilbakemelding på dine forespurt endringer!"
                    },
                    {
                        businessBookingModel: bookingdata,
                        emails: [bookingdata?.userEmail],
                        state: "sp_ConfirmBusinessBookingEmail",
                        title: "Funtlers har gitt tilbakemelding på dine forespurt endringer!",
                        subject: "Funtlers har gitt tilbakemelding på dine forespurt endringer!"
                    }
                );
                break;

            default:
                emailJobs.push({
                    businessBookingModel: bookingdata,
                    emails: ["support@funtlers.com"],
                    state: "Unknown",
                    title: "Unknown Booking State",
                    subject: "Noe gikk galt med bookingen"
                });
        }

        return emailJobs;
    };




    //const makeBookingEmailData = (bookingdata, Status) => {
    //    let state; // Declare the variable
    //    let title =null;

    //    
    //    switch (Status) {
    //        case "CANCELLED":
    //            state = "sp_CancelAllBusinessBookingEmail";
    //            title = "Funtlers har dessverre måtte avbestille din booking.";
    //            break;

    //        case "PARTIAL_CANCELLED":
    //            state = "sp_PartialCancelBusinessBookingEmail";
    //            title = "Funtlers har dessverre måtte kansellere deler av din booking.";
    //            break;

    //        case "DELETED":
    //            state = "sp_DeleteAllBusinessBookingEmail";
    //            title = "Funtlers har dessverre måtte avslå din bookingforespørsel.";
    //            break;
    //        // Add other cases as needed
    //        case "PARTIAL_DELETED":
    //            state = "sp_PartialDeleteBusinessBookingEmail";
    //            title = "Funtlers har dessverre måtte avslå deler av din bookingforespørsel.";
    //            break;
    //        // Add other cases as needed
    //        case "CONFIRMED":
    //            state = "sp_ConfirmBusinessBookingEmail";
    //            break;

    //        default:
    //            state = "Unknown"; // Default value if no case matches
    //    }

    //    // You can return an object with the data
    //    return {
    //        businessBookingModel: bookingdata,
    //        emails: [userObject?.user?.email, bookingdata?.userEmail],
    //        state: state,
    //        title: title
    //    };
    //};


    const handleDeleteClose = (row) => {
        setShowDeletePopup(false)
        setShowModalDone(false);
        setSelectedRow(null);
    }


    const handleDelete = (row) => {

        setSelectedRow(row);
        setShowDeletePopup(true);
    };


    // ✅ Open popup
    const handleCancel = (row) => {
        setSelectedRow(row);
        setShowCancelPopup(true);
    };

    // ✅ Close popup
    const handleCancelClose = () => {
        setSelectedRow(null);
        setShowCancelPopup(false);
    };

    // ✅ Save changes
    const handleCancelSaveChanges = (row,newOperation) => {
        


        setLoading(true);

        // 🔹 Prepare updated activities
        //const updatedActivities = row.activities.map((activity) => {
        //    if (activity.reason && activity.reason.trim() !== "") {
        //        return {
        //            ...activity,
        //            isCanceled: true,   // ✅ Mark as canceled if reason exists
        //        };
        //    }
        //    return activity;
        //});


        // 🔹 Remove the canceled activities from payload
        const updatedRow = row;

        // total vs deleted
        const total = row.activities.length;
        const canceledCount = row.activities.filter(a => a.isCanceled).length;

        const Operation = (canceledCount === total || total === 1) ? "CANCELLED" : "PARTIAL_CANCELLED";
        // decide new status row.
        const newStatus = (canceledCount === total || total === 1) ? "CANCELLED" : "CHANGES_REQUIRED_USER";

        // 🔹 First update booking data if not fully canceled
        if (canceledCount > 0 && total >= 1) {


            FetchService.UpdateBusinessBookinglRequest(updatedRow);
        }
    

        // 🔹 Then update status

        FetchService.GenerateBookingEmail(makeBookingEmailData(updatedRow, Operation))
            .then(() => {


                FetchService.UpdateBookingStatus(row.businessBookingId, newStatus)
                    .then(() => {

                   

                        setShowCancelPopup(false);
                        setShowModalDone(true);

                        if (Operation === "PARTIAL_CANCELLED") {
                            setShowModalMessage("Deler av bestillingsforespørselen din er kansellert i henhold til avbestillingsreglene. Bestillingen er oppdatert med de gjenværende aktivitetene og sendt til brukeren.");

                        }
                        else {
                            setShowModalMessage("Din bestilling har blitt avbestilt iht avbestillingsvilkår.");
                        }
                        // refresh parent grid/list here if needed
                        setTimeout(() => {
                            setLoading(false);
                            RefreshData();
                        }, 3000); // waits 3 seconds
                        //console.log(`Updating booking ${row.businessBookingId} → ${newStatus}`);

                    })
                    .catch((err) => {
                        console.error("Update failed", err);
                    });
            })
            .catch((err) => {
                console.error("Update failed", err);
            })
    };



    // ✅ Save changes
    const handleCancelPartialChanges = (row) => {
        


        setLoading(true);

   

        // 🔹 Remove the canceled activities from payload
        const updatedRow = row

        // total vs deleted
        const total = row.activities.length;
        const canceledCount = row.activities.filter(a => a.isCanceled).length;

        const Operation = (canceledCount === total || total === 1) ? "CANCELLED" : "PARTIAL_CANCELLED";
        // decide new status row.
        const newStatus = (canceledCount === total || total === 1) ? "CANCELLED" : "CHANGES_REQUIRED_USER";


        // 🔹 First update booking data if not fully canceled
        if (canceledCount > 0 && total >= 1) {


            FetchService.UpdateBusinessBookinglRequest(updatedRow);
        }

        // 🔹 Then update status

        FetchService.GenerateBookingEmail(makeBookingEmailData(updatedRow, Operation))
            .then(() => {


                FetchService.UpdateBookingStatus(row.businessBookingId, newStatus)
                    .then(() => {


                        setShowCancelPopup(false);
                        setShowModalDone(true);

                        if (Operation === "PARTIAL_CANCELLED") {
                            setShowModalMessage("Deler av bestillingsforespørselen din er kansellert i henhold til avbestillingsreglene. Bestillingen er oppdatert med de gjenværende aktivitetene og sendt til brukeren.");

                        }
                        else {
                            setShowModalMessage("Din bestilling har blitt avbestilt iht avbestillingsvilkår.");
                        }
                        // refresh parent grid/list here if needed
                        setTimeout(() => {
                            setLoading(false);
                            RefreshData();
                        }, 3000); // waits 3 seconds
                        //console.log(`Updating booking ${row.businessBookingId} → ${newStatus}`);

                    })
                    .catch((err) => {
                        console.error("Update failed", err);
                    });
            })
            .catch((err) => {
                console.error("Update failed", err);
            })
    };



    // Handle Review Changes


    //handleReviewChangesRequest(data) => {


    //}

    //const getStatusConfig = (status) => {
    //      const configs = {
    //          confirmed: { text: 'Godkjent', dotColor: '#10b981' },
    //          pending: { text: 'Pending', dotColor: '#f59e0b' },
    //          cancelled: { text: 'Avbrutt', dotColor: '#ef4444' },
    //          completed: { text: 'Fullført', dotColor: '#3b82f6' }
    //      };
    //    return configs[status.toLowerCase()] || { text: 'Ukjent', dotColor: '#6b7280' };

    //  }

    const getStatusConfig = (status) => {
        
        if (!status) return { text: "", dotColor: "#ffff" };

        return (
            statusConfigs[status.toLowerCase()] || {
                text: "",
                dotColor: "#ffff",
            }
        );
    };




    const getStatusTranslation = (status) => {
        const configs = {
            pending: "Avventer bekreftelse"
        };
        
        return configs[status.toLowerCase()]?.toUpperCase() || 'Ukjent';
    }

    const renderCollapsibleContent = (row) => {
        // Define SVG icons as reusable components
        // Define SVG icons as reusable components
        const InfoIcon = () => (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="16" x2="12" y2="12" />
                <line x1="12" y1="8" x2="12" y2="8" />
            </svg>
        );

        const CalendarIcon = () => (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
            </svg>
        );

        const ClockIcon = () => (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
            </svg>
        );

        const CityIcon = () => (
            <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                {/* Globe outline (slightly thinner stroke) */}
                <circle cx="12" cy="12" r="9.5" />

                {/* Crosshair lines (subtle grid) */}
                <line x1="2" y1="12" x2="22" y2="12" /> {/* Equator */}
                <line x1="12" y1="2" x2="12" y2="22" /> {/* Prime Meridian */}

                {/* Curved latitude lines (more pronounced) */}
                <path d="M4 8a8 8 0 0 1 16 0" />  {/* Northern hemisphere */}
                <path d="M4 16a8 8 0 0 1 16 0" />  {/* Southern hemisphere */}

                {/* Optional: Small dots for key cities */}
                <circle cx="16" cy="9" r="0.75" fill="currentColor" />  {/* Top-right city */}
                <circle cx="8" cy="12" r="0.75" fill="currentColor" />  {/* Mid-left city */}
                <circle cx="14" cy="16" r="0.75" fill="currentColor" /> {/* Bottom-right city */}
            </svg>
        );

        const UsersIcon = () => (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
        );

        const PriceTagIcon = () => (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 2l9 4.9V17L12 22l-9-4.9V7L12 2" />
                <path d="M13 17h.01" />
                <path d="M13 13.5h.01" />
                <path d="M13 10h.01" />
            </svg>
        );

        const MoneyIcon = () => (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="12" y1="1" x2="12" y2="23" />
                <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
            </svg>
        );

        const MoneyBigIcon = () => (
            <div class="p-2 bg-green-100 rounded-full"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-dollar-sign w-4 h-4 text-green-600" aria-hidden="true"><line x1="12" x2="12" y1="2" y2="22"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg></div>
        );

        const colmd = row?.city ? 'col-md-4' : 'col-md-6';

        const totalPrice = row.activities.reduce((acc, activity) => {
            return acc + (activity.personCount || 0) * (activity.pricePerPerson || 0);
        }, 0);

        return (
            <div className="p-3   ">
                {/* HEADER SECTION */}
                <div className="mb-4 p-2 bg-white  ">

                    <h5 className=" text-muted uppercase bb-1 mb-3 p-2"><strong>Ordredetaljer</strong></h5>

                    <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">

                        <div>
                            <spam className="mb-1 d-flex align-items-center text-base">
                                <InfoIcon />
                                <span className="ms-2 fw-bold">{row.bookingName || 'Ukjent navn'}</span>
                            </spam>
                        </div>

                        <div className="mt-2 mt-md-0 text-base">
                            <span
                                className={`badge   p-2`}
                                dangerouslySetInnerHTML={{
                                    __html: row.statusHeading || 'Ukjent status'
                                }}
                            ></span>
                        </div>
                    </div>

                    <div className="row">
                        <div className={`${colmd} mb-2 mb-md-0`}>
                            <p className="mb-1 d-flex align-items-center">
                                <CalendarIcon />
                                <b className="ms-2">Dato:</b>
                                <span className="ms-2">
                                    {dayjs(row.bookingDate).locale('nb').format('DD. MMMM YYYY').toUpperCase()}
                                </span>
                            </p>
                        </div>
                        <div className={`${colmd}`}>
                            <p className="mb-1 d-flex align-items-center justify-content-center w-100">
                                <ClockIcon />
                                <b className="ms-2">Opprettet:</b>
                                <span className="ms-2">
                                    {dayjs(row.bookingDate).format('HH:mm').toUpperCase()}
                                </span>
                            </p>
                        </div>

                        {row.city && <div className={`${colmd}`}>
                            <p className="mb-1 d-flex align-items-center justify-content-center w-100">
                                <CityIcon />
                                <b className="ms-2">By:</b>
                                <span className="ms-2">
                                    {(row?.city === "all" ? "Alle" : row?.city)?.toUpperCase()}
                                </span>
                            </p>
                        </div>
                        }
                    </div>
                </div>

                {/* ACTIVITIES SECTION */}
                <h5 className="p-2 bg-white  shadow-sm d-flex align-items-center bb-1">
                    <UsersIcon />
                    <span className="ms-2">Aktiviteter ({row.activities.length})</span>
                </h5>

                <div className="bg-white row row2 bb-1" >
                    {row.activities.map((activity, index) => (
                        <div key={index} className=" col-md-6 mb-2">
                            <div
                                className={`d-flex align-items-start p-1 h-100 ${(activity.isCanceled || activity.isDeleted) &&  activity.reason && activity.reason.trim() !== ""
                                    ? "error-message"   // apply custom error class
                                    : "bg-white"        // normal background
                                    }`}
                                style={{
                                    position: "relative",
                                    top: "8px",
                                    right: "7px",
                                    zIndex: 1,
                                }}
                            >
                                {/* Show button if reason exists */}
                                {(activity.isCanceled || activity.isDeleted) && activity.reason && activity.reason.trim() !== "" && (
                                    <button
                                        className="btn btn-sm btn-danger ms-2"
                                        style={{
                                            position: "absolute",
                                            top: "8px",
                                            right: "7px",
                                            zIndex: 1,
                                        }}
                                    >
                                        BOOKINGFORESPØRSELEN ER AVBRUTT
                                    </button>
                                )}
                                <div className="searchResultContent BookingCardGrid flex-fill"
                                    style={{
                                    padding:"2px"
                                    }}
                                >
                                    <h6 className="mb-2 d-flex align-items-center">
                                        <InfoIcon />
                                        <b className="ms-2">
                                            {activity.activityName?.slice(0, 48)}
                                            {activity.activityName?.length > 48 ? '...' : ''}
                                        </b>
                                    </h6>

                                    <div className="ms-4">
                                        <p className="mb-2 d-flex align-items-center">
                                            <CalendarIcon />
                                            <b className="ms-2">Dato:</b>
                                            <span className="ms-2">
                                                {dayjs(activity.activityDate).locale('nb').format('DD. MMMM YYYY').toUpperCase()}
                                            </span>
                                        </p>

                                        <p className="mb-2 d-flex align-items-center">
                                            <ClockIcon />
                                            <b className="ms-2">Tid:</b>
                                            <span className="ms-2">
                                                {activity.timeFrom.slice(0, 5) || 'N/A'} - {activity.timeTo.slice(0, 5) || 'N/A'}
                                            </span>
                                        </p>

                                        <p className="mb-2 d-flex align-items-center">
                                            <UsersIcon />
                                            <b className="ms-2">Personer:</b>
                                            <span className="ms-2">{activity.personCount}</span>
                                        </p>
                                        {
                                            activity?.category && <p className="mb-2 d-flex align-items-center">
                                                <UsersIcon />
                                                <b className="ms-2">Kategori:</b>
                                                <span className="ms-2">{CategoryObjecy(activity.category)?.value}</span>
                                            </p>

                                        }

                                        <p className="mb-2 d-flex align-items-center">
                                            <PriceTagIcon />
                                            <b className="ms-2">Pris per person:</b>
                                            <span className="ms-2">{activity.pricePerPerson} NOK</span>
                                        </p>

                                        <p className="mb-0 d-flex align-items-center">
                                            <MoneyIcon />
                                            <b className="ms-2">Total aktivitet:</b>
                                            <span className="ms-2">
                                                {(activity.personCount || 0) * (activity.pricePerPerson || 0)} NOK
                                            </span>
                                        </p>
                                    </div>
                                    {activity.reason && activity.reason.trim() !== "" && (
                                        <div
                                            style={{

                                                width: "70%",
                                                textAlign: "left",
                                                padding: "9px",

                                            }}
                                        >
                                            <div
                                                className="admin-comment mt-3 flex items-start gap-2 p-2 rounded-md bg-gray-50 border border-gray-200"
                                                style={{ minHeight: "60px", maxWidth: "100%" }}
                                            >
                                                <i className="ri-chat-1-line text-purple text-lg mt-1"></i>
                                                <div className="flex-1 overflow-hidden">
                                                    <b className="text-purple block mb-1">Funtlers kommentar:</b>
                                                    <p className="mb-0 text-gray-700 break-words whitespace-pre-line" style={{ wordBreak: "break-word" }}>
                                                        {activity.reason}
                                                    </p>
                                                </div>
                                            </div>



                                        </div>
                                    )}
                                </div>
                                {/* Cancel Reason (conditional) */}
                       
                            </div>
                        </div>
                    ))}

                    {/* TOTAL COST SECTION */}
                    <div className="bg-green p-3    align-items-center mt-3 p-3 bg-gradient-to-r from-green-50 to-emerald-50 rounded-lg border border-green-200">
                        <h5 className="mb-0 d-flex align-items-center justify-content-center">
                            <MoneyBigIcon />
                            <b className="ms-2">Total kostnad:</b>
                            <span className="ms-2 text-green-600">{totalPrice} NOK</span>
                        </h5>
                    </div>
                </div>

                {/* ADDITIONAL INFORMATION SECTION */}
                <h5 className="mt-4 p-2 bg-white  shadow-sm d-flex align-items-center bb-1">
                    <InfoIcon />
                    <span className="ms-2">Tilleggsinformasjon</span>
                </h5>

                <div className="bg-white p-3  shadow-sm mb-4">
                    {row.additionalInfo ? (
                        <p className="mb-0">{row.additionalInfo}</p>
                    ) : (
                        <p className="mb-0 text-muted fst-italic">Ingen tilleggsinformasjon oppgitt</p>
                    )}
                </div>


            </div>
        );
    };



    if (error) {
        return <div className="error-message">{error}</div>;
    }

    return (
        <>
            <LoadingOverlay
                active={isLoading }
                spinner
                text="Behandler forespørselen din"
                styles={{
                    overlay: {
                        zIndex: 6000,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#000000a1', // semi-transparent black background
                    },
                }}
            ></LoadingOverlay>

            <div className="booking-details-page">
                <div className="booking-details-page booking-details-page-admin">
                    <div className="booking-wrapper">
                        <header className="booking-header ">
                            <div ></div>
                            <h1 class="form_heading inner_header_main fw-bold">BESTILLINGER</h1>
                            <p className="booking-subtitle text-start text-uppercase">Her finner du en oversikt over alle B2B kunder sine forespurte bookinger og deres status. Administrator har mulighet til å endre eller avbestille aktiviteter ved behov.</p>
                        </header>
                        {/* Render grid only if bookings data is available */}
                        {bookings && (
                            <div className="booking-tabs" style={{ zoom: 0.85 }}>
                                {/* TAB BUTTONS */}
                                <div
                                    className="tab-buttons"
                                    style={{ display: "flex", gap: "10px", marginBottom: "15px"  }}
                                >
                                    {Object.values(statusConfigs) // loop over all configs
                                        .sort((a, b) => {
                                            const order = Object.values(statusConfigs).map((s) => s.statuscode);
                                            return order.indexOf(a.statuscode) - order.indexOf(b.statuscode);
                                        })
                                        .map((cfg) => {
                                            // count bookings in this status
                                            const rows = bookings.data.filter(
                                                (row) =>
                                                    (row.status || "Ukjent").toLowerCase() ===
                                                    cfg.statuscode.toLowerCase()
                                            );

                                            return (
                                                <button
                                                    key={`label-${cfg.statuscode}`}
                                                    onClick={() => setActiveTab(cfg.statuscode)} // set by statuscode
                                                    style={{
                                                        cursor: "pointer",
                                                        padding: "6px 12px",
                                                        border: "1px solid #ccc",
                                                        borderRadius: "4px",
                                                        background:
                                                            activeTab === cfg.statuscode ? "#fff" : "#f5f5f5",
                                                        color: activeTab === cfg.statuscode ? "#fb923c" : "#000",
                                                    }}
                                                >
                                                    {cfg.text}
                                                    <span
                                                        style={{
                                                            marginLeft: "6px",
                                                            padding: "2px 6px",
                                                            fontSize: "13px",
                                                            fontWeight: "bold",
                                                            color: "white",
                                                            background: cfg.dotColor,
                                                            borderRadius: "999px",
                                                        }}
                                                    >
                                                        {rows.length}
                                                    </span>
                                                </button>
                                            );
                                        })}
                                </div>

                                {/* TAB CONTENT */}
                                <div className="tab-contents">
                                    {Object.values(statusConfigs)
                                        .sort((a, b) => {
                                            const order = Object.values(statusConfigs).map((s) => s.statuscode);
                                            return order.indexOf(a.statuscode) - order.indexOf(b.statuscode);
                                        })
                                        .map((cfg) => {
                                            // filter bookings for this tab
                                            const rows = bookings.data.filter(
                                                (row) =>
                                                    (row.status || "Ukjent").toLowerCase() ===
                                                    cfg.statuscode.toLowerCase()
                                            );

                                            return (
                                                <div
                                                    key={`content-${cfg.statuscode}`}
                                                    className="tab-panel"
                                                    style={{
                                                        display: activeTab === cfg.statuscode ? "block" : "none", // match active tab
                                                        marginTop: "10px",
                                                    }}
                                                >
                                                    <CollapsibleGrid
                                                        uniquieid={"businessBookingId"}
                                                        columnstranslate={["Ordre", "Ordre-ID", "Dato","LAGRET AV", "Status"]}
                                                        columns={["name", "orderID", "bookingDateOrg","userEmail", "statushtml"]}
                                                        data={rows}
                                                        actions={[
                                                            //{
                                                            //    label: "REDIGERE",
                                                            //    icon: "edit",
                                                            //    className: "edit-button",
                                                            //    onClick: (row) => handleEdit(row),
                                                            //    visibleIf: (row) =>
                                                            //        checkEditVisibility(row) &&
                                                            //        row.status !== "DELETED",
                                                            //},
                                                            //{
                                                            //    label: "SLETT",
                                                            //    icon: "trash",
                                                            //    className: "delete-button",
                                                            //    onClick: (row) => handleDelete(row),
                                                            //    visibleIf: (row) =>
                                                            //        checkPendingorPickStatus(row) &&
                                                            //        row.status !== "DELETED",
                                                            //},
                                                            {
                                                                label: "FORESPØR ENDRINGER",
                                                                icon: "edit",
                                                                className: "edit-button",
                                                                onClick: (row) => handleEdit(row),
                                                                visibleIf: (row) =>
                                                                   checkPendingorPickStatus(row),
                                                            },
                                                            {
                                                                label: "FORESPØR ENDRINGER",
                                                                icon: "edit",
                                                                className: "edit-button",
                                                                onClick: (row) => handleEdit2(row),
                                                                visibleIf: (row) =>
                                                                    row.status === "CONFIRMED"
                                                            },


                                                            {
                                                                label: "SLETT",
                                                                icon: "ri-delete-bin-7-line",
                                                                style: { backgroundColor: 'red' },
                                                                className: "cancel-button",
                                                                onClick: (row) => handleDelete(row),
                                                                visibleIf: (row) =>
                                                                    checkPendingorPickStatus(row) &&
                                                                    row.status !== "DELETED" &&
                                                                    row.status !== "CANCELLED"
                                                                    ,
                                                            },
                                                            {
                                                                label: "AVBESTILL",
                                                                icon: "ri-close-circle-line",
                                                                style: { backgroundColor: '#ff6666' }, // or pick another color
                                                                className: "cancel-button",
                                                                onClick: (row) => handleCancel(row),
                                                                visibleIf: (row) =>
                                                                    row.status === "CONFIRMED"  &&
                                                                    row.status !== "CANCELLED" &&
                                                                    row.status !== "DELETED",
                                                            },

                                                            {
                                                                label: "BEKREFT BOOKING",
                                                                icon: "ri-checkbox-circle-line",
                                                                style: { backgroundColor: 'green' },
                                                                className: "cancel-button",
                                                                onClick: (row) => handleConfirmBookingChanges(row),
                                                                visibleIf: (row) =>
                                                                    checkPendingorPickStatus(row) &&
                                                                    row.status !== "DELETED" &&
                                                                    row.status !== "CANCELLED" 
                                                                ,
                                                            },

                                                            {
                                                                label: "GJENNOMGÅ ENDRINGER",
                                                                icon: "ri-chat-check-line",
                                                                style: { backgroundColor: 'orange' },
                                                                className: "cancel-button",
                                                                onClick: (row) => handleShowReviewChanges(row),
                                                                visibleIf: (row) =>
                                                                    row.status === "CHANGES_REQUIRED_ADMIN"
                                                                ,
                                                            },

                                                           



                                                        ]}
                                                        renderExpandedContent={renderCollapsibleContent}
                                                        expandMode="single"
                                                        onActionClick={(action, row) => {
                                                            //console.log("Parent noticed click:", action.label, row);
                                                            stopAutoRefresh(); // ✅ pause refresh here
                                                        }}
                                                    />
                                                </div>
                                            );
                                        })}
                                </div>
                            </div>
                        )}



                        {showPopup &&
                            (<>
                                <div className="overlay-pop">
                                    <div className="modal-pop  modal-edit custom-min-width-modal modal-lg modal-dialog-centered">
                                        {/* Close button pinned on top */}
                                        <div className="close-button">
                                            <button
                                                className="close-btn"
                                                onClick={() => {
                                                    setShowPopup(false);
                                                    setShowConfirmSaveModal(true);
                                                }}
                                            >
                                                ✖
                                            </button>
                                        </div>


                                        {/* Scrollable content */}
                                        <div className="p-cstm-17 overflow-y-auto overflow-x-hidden flex-1">
                                            <OrderPlan
                                                searchQuery={searchQuery}
                                                setSearchQuery={setSearchQuery}
                                                editButtons={null}
                                                action={JSON.parse(selectedRow.sessionData)?.action}
                                                className="scale-[0.8]"
                                                onChangeUpdate={(updatedData) => {
                                                    // 👈 this will fire every time child updates something
                                                    console.log("Booking data from child:", updatedData);
                                                    setCurrentBooking(updatedData); // store it in parent state
                                                }}
                                                isEditMode={true}
                                                EditData={{
                                                    heading: "REDIGER BOOKING FORESPØRSEL",
                                                    description:
                                                        "HER KAN DU SE GJENNOM OG OPPDATERE BOOKING FORESPØRSELEN. SJEKK INFORMASJONEN NØYE FØR DU SENDER INN EN ØNSKET ENDRING.",
                                                    Mode: "isEditBooking",
                                                    BookingDataParent: selectedRow,
                                                    View: "admin"
                                                }}
                                                onSave={() => {
                                                    
                                                    setShowPopup(false);
                                                    handleEditSaveChanges(currentBooking?.booking);

                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/* Confirm Save Modal */}

                            </>
                            )
                        }



                        {showPopup2 &&
                            (<>
                                <div className="overlay-pop">
                                    <div className="modal-pop  modal-edit custom-min-width-modal modal-lg modal-dialog-centered">
                                        {/* Close button pinned on top */}
                                        <div className="close-button">
                                            <button
                                                className="close-btn"
                                                onClick={() => {
                                                    setShowPopup2(false);
                                                    setShowConfirmSaveModal(true);
                                                }}
                                            >
                                                ✖
                                            </button>
                                        </div>


                                        {/* Scrollable content */}
                                        <div className="p-cstm-17 overflow-y-auto overflow-x-hidden flex-1">
                                            <OrderPlan
                                                searchQuery={searchQuery}
                                                setSearchQuery={setSearchQuery}
                                                editButtons={null}
                                                action={JSON.parse(selectedRow.sessionData)?.action}
                                                className="scale-[0.8]"
                                                onChangeUpdate={(updatedData) => {
                                                    // 👈 this will fire every time child updates something
                                                    console.log("Booking data from child:", updatedData);
                                                    setCurrentBooking(updatedData); // store it in parent state
                                                }}
                                                isEditMode={true}
                                                EditData={{
                                                    heading: "REDIGER BOOKING FORESPØRSEL",
                                                    description:
                                                        "HER KAN DU SE GJENNOM OG OPPDATERE BOOKING FORESPØRSELEN. SJEKK INFORMASJONEN NØYE FØR DU SENDER INN EN ØNSKET ENDRING.",
                                                    Mode: "isEditBooking",
                                                    BookingDataParent: selectedRow,
                                                    View: "admin"
                                                }}
                                                onSave={() => {

                                                    debugger;
                                                    setShowPopup2(false);
                                                    handleEditSaveChanges(currentBooking?.booking,"Kunden har nå mottatt Funtlers sitt ønske om å endre deres bekreftede booking, og man venter nå på godkjenning fra kunden. Dersom du ikke hører fra kunden snarlig, bør du ta kontakt med kunden for å avklare endringen.","EDITED_CONFIRM");

                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/* Confirm Save Modal */}

                            </>
                            )
                        }



                    </div>
                </div>
            </div>


            {showReviewChangesModal && (<>
                <div className="overlay-pop">
                    <div className="modal-pop modal-lg modal-dialog-centered relative max-w-6xl">

                        <div className="modal-header">
                        {/* Close button fixed top-right */}
                        <div className="absolute top-4 right-4 z-10 mt-2 mb-2">





                            <button type="button" class="btn-close " aria-label="Close" onClick={() => setShowReviewChangesModal(false)}>                            </button>
                        </div>


                        {/* Heading */}
                        <div class="modal-title h4 mt-4 mb-2 custom-heading">Booking Endringsgjennomgang</div>
                        </div>

                        {/* Scrollable content */}
                        <div className=" overflow-y-auto overflow-x-hidden w-100 mb-4">
                            <BookingApproval
                                bookingData={selectedRow}
                                onSave={(payload) => {
                                    
                                    handleReviewChangesRequest(payload)
                                }}
                                onCancel={() => setShowReviewChangesModal(false)}
                            />
                        </div>
                    </div>
                </div>

                {/* Confirm Save Modal */}

            </>
            )}




            {showDeletePopup &&

                <Modal
                    show={showDeletePopup}
                    onHide={() => setShowDeletePopup(false)}
                    centered
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>ØNSKER DU Å SLETTE?</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {selectedRow?.activities?.length === 1 && 'Her kan du slette din bookingforespørsel, og trekke den tilbake. Merk at dette ikke kan reverseres.'}
                        {selectedRow?.activities?.length > 1 && 'Her kan du slette hele eller deler av din bookingforespørsel, og trekke den tilbake. Merk at dette ikke kan reverseres.'}
                        {/*{JSON.stringify(selectedRow)}*/}
                        {/*{JSON.stringify(selectedRow)}*/}

                        {selectedRow?.activities?.length > 0 && (
                            <div className="mt-3">
                                {selectedRow.activities.length > 1 ? (
                                    // ✅ MULTIPLE ACTIVITIES
                                    <>
                                        <p className="mb-2">
                                            <strong>Velg aktiviteter:</strong>
                                        </p>

                                        {selectedRow.activities.map((activity, idx) => (
                                            <div key={idx} style={{ marginBottom: "10px" }}>
                                                <label
                                                    style={{ display: "block", marginBottom: "5px" }}
                                                    className="fz-18"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        className="activity-checkbox"
                                                        value={activity.activityId}
                                                        checked={activity.isDeleted || false}
                                                        onChange={(e) => {
                                                            const updated = {
                                                                ...selectedRow,
                                                                activities: selectedRow.activities.map((a, i) =>
                                                                    i === idx ? { ...a, isDeleted: e.target.checked, reason:null } : a
                                                                ),
                                                            };
                                                            setSelectedRow(updated);
                                                        }}
                                                    />
                                                    {activity.activityName}{" "}
                                                    {dayjs(activity.activityDate)
                                                        .locale("nb")
                                                        .format("DD. MMMM YYYY")
                                                        .toUpperCase()}{" "}
                                                    {activity.timeFrom.slice(0, 5) || "N/A"} - {activity.timeTo.slice(0, 5) || "N/A"}
                                                </label>

                                                {activity.isDeleted && (
                                                    <textarea
                                                        placeholder="Skriv årsak til sletting"
                                                        value={activity.reason || ""}
                                                        onChange={(e) => {
                                                            const updated = {
                                                                ...selectedRow,
                                                                activities: selectedRow.activities.map((a, i) =>
                                                                    i === idx ? { ...a, reason: e.target.value } : a
                                                                ),
                                                            };
                                                            setSelectedRow(updated);
                                                        }}
                                                        style={{
                                                            width: "100%",
                                                            padding: "6px",
                                                            fontSize: "0.9em",
                                                            marginTop: "5px",
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        ))}
                                    </>
                                ) : (
                                    // ✅ ONLY ONE ACTIVITY → NO HEADING, NO CHECKBOX
                                    <div>
                                        {/*<p className="fz-18" style={{ marginBottom: "5px" }}>*/}
                                        {/*    {selectedRow.activities[0].activityName}{" "}*/}
                                        {/*    {dayjs(selectedRow.activities[0].activityDate)*/}
                                        {/*        .locale("nb")*/}
                                        {/*        .format("DD. MMMM YYYY")*/}
                                        {/*        .toUpperCase()}{" "}*/}
                                        {/*    {selectedRow.activities[0].timeFrom.slice(0, 5) || "N/A"} -{" "}*/}
                                        {/*    {selectedRow.activities[0].timeTo.slice(0, 5) || "N/A"}*/}
                                            {/*</p>*/}

                                            <strong>
                                                {selectedRow.activities[0].activityName.toUpperCase()}{" "}
                                                {dayjs(selectedRow.activities[0].activityDate)
                                                    .locale("nb")
                                                    .format("DD. MMMM YYYY")
                                                    .toUpperCase()}
                                            </strong>

                                        <textarea
                                            placeholder="Skriv årsak til sletting"
                                            value={selectedRow.activities[0].reason || ""}
                                                onChange={(e) => {

                                                const updated = {
                                                    ...selectedRow,
                                                    activities: [
                                                        { ...selectedRow.activities[0], reason: e.target.value },
                                                    ],
                                                };
                                                setSelectedRow(updated);
                                            }}
                                            style={{
                                                width: "100%",
                                                height:"106px",
                                                padding: "6px",
                                                fontSize: "0.9em",
                                                marginTop: "5px",
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                        )}


                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            className="px-4 py-2 rounded-lg bg-green-500 text-white hover:bg-green-700 disabled:opacity-50"
                            disabled={
                                selectedRow?.activities?.length > 1 &&
                                !selectedRow.activities.some((a) => a.isDeleted)
                            }
                            onClick={() => {
                                if (
                                    selectedRow.activities.length > 1 &&
                                    !selectedRow.activities.some((a) => a.isDeleted)
                                ) {
                                    alert("Velg minst én aktivitet for kansellering.");
                                    return;
                                }
                                handleDeleteSaveChanges(selectedRow);
                            }}
                        >
                            {selectedRow.activities.length > 1 && selectedRow.activities.some((a) => a.isDeleted)
                                ? `Ja (${selectedRow.activities.filter((a) => a.isDeleted).length})`
                                : "Ja"}
                        </button>

                        <button
                            className="px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-700"
                            onClick={() => handleDeleteClose(selectedRow)}
                        >
                            Nei
                        </button>
                    </Modal.Footer>
                </Modal>

            }

            {showCancelPopup && (
                <Modal
                    show={showCancelPopup}
                    onHide={() => setShowCancelPopup(false)}
                    centered
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>AVBESTILL</Modal.Title>
                    </Modal.Header>

                  <Modal.Body>
  Ønsker du å avbestille? Denne forespørselen kan ikke reveseres. 
  Avbestillingsvilkår ble godkjent ved bestillingsforespørsel, 
  så sørg for at du er innenfor gitte avbestillingsrammer før du avbestiller 
  da kostnader kan tilkomme. Dersom du er usikker kan du ta kontakt med support@funtlers.com.

  {selectedRow?.activities?.length > 1 ? (
    <div className="mt-3">
      <p className="mb-2">
        <strong>
          Velg følgende av {selectedRow.activities.length} for kansellering:
        </strong>
      </p>

      {selectedRow.activities.map((activity, idx) => (
        <div key={idx} style={{ marginBottom: "10px" }}>
          <label style={{ display: "block", marginBottom: "4px" }}>
            <input
              type="checkbox"
              className="activity-checkbox"
              value={activity.activityId}
              checked={activity.isCanceled || false}
              onChange={(e) => {
                const updated = {
                  ...selectedRow,
                  activities: selectedRow.activities.map((a, i) =>
                    i === idx ? { ...a, isCanceled: e.target.checked ,reason :null} : a
                  ),
                };
                setSelectedRow(updated);
              }}
            />
            {activity.activityName}{" "}
            {dayjs(activity.activityDate).locale("nb").format("DD. MMMM YYYY").toUpperCase()}
          </label>

          {/* Cancel reason when checked */}
          {activity.isCanceled && (
            <textarea
              placeholder="Skriv årsak til kansellering"
              value={activity.reason || ""}
              onChange={(e) => {
                const updated = {
                  ...selectedRow,
                  activities: selectedRow.activities.map((a, i) =>
                    i === idx ? { ...a, reason: e.target.value } : a
                  ),
                };
                setSelectedRow(updated);
              }}
              style={{
                width: "100%",
                padding: "6px",
                fontSize: "0.9em",
                marginTop: "5px",
              }}
            />
          )}
        </div>
      ))}
    </div>
  ) : (
    // ✅ Case: Only one activity → always show reason textbox
   selectedRow?.activities?.[0] && selectedRow?.activities?.length===1 && (
      <div className="mt-3">
                                        <strong>
                                            {selectedRow.activities[0].activityName.toUpperCase()}{" "}
                                            {dayjs(selectedRow.activities[0].activityDate)
                                                .locale("nb")
                                                .format("DD. MMMM YYYY")
                                                .toUpperCase()}
                                        </strong>
        
        <textarea
          placeholder="Skriv årsak til kansellering"
          value={selectedRow.activities[0].reason || ""}
          onChange={(e) => {
            const updated = {
              ...selectedRow,
              activities: [
                { ...selectedRow.activities[0], isCanceled: true, reason: e.target.value }
              ],
            };
            setSelectedRow(updated);
          }}
          style={{
            width: "100%",
            padding: "6px",
            fontSize: "0.9em",
            marginTop: "10px",
            height:"88px"
          }}
        />
      </div>
    )
  )}
</Modal.Body>


                    <Modal.Footer>
                        <button
                            className="px-4 py-2 rounded-lg bg-green-500 text-white hover:bg-green-700 disabled:opacity-50"
                            disabled={
                                selectedRow?.activities?.length > 1 &&
                                !selectedRow.activities.some((a) => a.isCanceled)
                            }
                            onClick={() => {
                                if (
                                    selectedRow.activities.length > 1 &&
                                    !selectedRow.activities.some((a) => a.isCanceled)
                                ) {
                                    alert("Velg minst én aktivitet for kansellering.");
                                    return;
                                }
                                handleCancelSaveChanges(selectedRow);
                            }}
                        >
                            {selectedRow.activities.length > 1 && selectedRow.activities.some((a) => a.isCanceled)
                                ? `Ja (${selectedRow.activities.filter((a) => a.isCanceled).length})`
                                : "Ja"}
                        </button>

                        <button
                            className="px-4 py-2 rounded-lg bg-red-500 text-white hover:bg-red-700"
                            onClick={() => handleCancelClose(selectedRow)}
                        >
                            Nei
                        </button>
                    </Modal.Footer>
                </Modal>
            )}



            {showModalDone &&
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0,0,0,0.5)", // 🔹 background overlay
                        zIndex: 6999, // just under the alert
                    }}
                >
                    <Alert className="col-md-5" style={{
                        position: "fixed",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        zIndex: 7000
                    }}
                        show={showModalDone} variant="success">
                        <p
                            className=" text-gray-700 leading-relaxed flex-wrap items-center"
                            style={{ whiteSpace: "normal", wordBreak: "break-word", display: "inline-block" }}
                            dangerouslySetInnerHTML={{ __html: showModalMessage }}
                        ></p>
                        <hr />
                        <div className="d-flex justify-content-end">
                            <button className="btnOrder" onClick={() => { setShowModalDone(false) }} variant="outline-success">
                                LUKK
                            </button>
                        </div>
                    </Alert>
                </div>
            }

        </>
    );
}

export default BookingDetailsPageAdmin;